import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Making Peace with the Voices in Your Head',
  slug: 'making-peace-with-the-voices-in-your-head',
  category: 'IFS',
  date: '2026-02-06',
  image: 'https://dpnelson.com/wp-content/uploads/2026/02/making-peace.png',
  excerpt: 'Ever try to fall asleep and end up refereeing a full-blown town hall meeting inside your skull?',
  body: `Ever try to fall asleep and end up refereeing a full-blown town hall meeting inside your skull? I know that one well. I've had nights where one part of me is planning my future, another is catastrophizing about tomorrow's email, and a third is critiquing the whole situation like it's auditioning for a reality show panel. Not exactly restful.

Underneath all that noise, something simple is happening: different parts of you are trying to keep you safe in their own clumsy way. One part wants to avoid embarrassment. Another pushes you toward something you actually want but hate admitting out loud. And then there's the loud one—the "we're running out of time" part—who feels like it's been on double shifts since 2003.

I've watched this shift happen in real time. Sometimes a client will be mid-rant, stop, blink, and say something like, "Huh… that actually makes sense." You don't have to silence your parts. You just have to listen with a little curiosity.

I remember one client telling me, "It felt like the room finally quieted down long enough for a grown-up to walk in." That "grown-up" is the Self—the steady center you forget you have when everything inside gets loud.

## A Simple Practice

And here's something small you can try the next time your mind spirals (I still do this when I get flustered):

Just ask one of the louder voices, _What are you afraid would happen if you stopped talking?_

Don't negotiate. Don't push. Just listen. It's strange how quickly things soften when a part feels heard.

Making peace with your inner world isn't about achieving silence. It's about realizing you're allowed to lead the room—not fight it.

If any of this stirs something in you, call me at 415-869-0411. This is the kind of work I help people do through Internal Family Systems coaching.`,
}

export default post
